var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteCgi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "58px",
    viewBox: "0 0 74 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u201C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "background-quotes",
    fill: "#7DE2D1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,58 L31,28.0362538 L16.9252874,28.0362538 L16.9252874,21.9033233 C16.9252874,17.8731118 20.6666667,15.5951662 26.0114943,15.5951662 L31,15.5951662 L31,0 L17.816092,0 C7.66091954,0 0,9.11178248 0,20.326284 L0,58 L31,58 Z M74,58 L74,28.0362538 L59.9252874,28.0362538 L59.9252874,21.9033233 C59.9252874,17.8731118 63.6666667,15.5951662 69.0114943,15.5951662 L74,15.5951662 L74,0 L60.816092,0 C50.6609195,0 43,9.11178248 43,20.326284 L43,58 L74,58 Z",
    id: "\\u201C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteCgi);
export default __webpack_public_path__ + "static/media/quote-cgi.5897c081.svg";
export { ForwardRef as ReactComponent };